import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useAuth } from '../Authentification/Auth';
import { IdBCContext } from '../IdBCContext';
import API_BASE_URL from './config';

const AppelAPILinkContactBilanCarbone = ({mail, lancerLink, setLancerLink, }) => {
    const { token, fetchToken, isTokenExpired } = useAuth();
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { idBC } = useContext(IdBCContext);
  
    useEffect(() => {
        isTokenExpired()
      }, []);
    
    useEffect(() => {
      // Vérifier si le token est disponible avant de faire la requête
      if (token && lancerLink) { 
        fetchData();
       }
    }, [token, lancerLink]); // Se ré-exécute lorsque `token` change
  
    const fetchData = async () => {
        console.log(mail)
    if(mail==""){
        mail = "mm@pp.fr"
    }
    setLoading(true);
    const apiUrl = `${API_BASE_URL}/aps_Contact_LinkBilanCarbone`;
    const data = {
        IdBC: idBC,
        email: mail
    };
    const options = {
    headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
    }
    };
    
    try {
        const resultLinkContactBilanCarbone = await axios.post(apiUrl, data, options);

        // Mettre à jour la réponse de l'API dans le composant parent
        // setApiResponse(resultLinkContactBilanCarbone.data);
        setLancerLink(false);

        } catch (error) {
            console.error("Erreur lors de l'envoi de la requête :", error);
            setResponse('Erreur lors de la récupération des données.');
        } finally {
            setLoading(false);
    }
    };


    return (null);
    };
  
  export default AppelAPILinkContactBilanCarbone;
